exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-knob-dialog {\n  display: block;\n  width: 700px;\n}\n\n/* --- Mobile --- */\n@media only screen and (max-width: 768px) {\n  fi-knob-dialog {\n    width: 100%;\n  }\n}", ""]);

// exports
